import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'home',
      component: require('@/pages/Home').default
    },
    {
      path: '/product',
      name: 'product',
      component: require('@/pages/Product').default
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: require('@/pages/Pricing').default
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: require('@/pages/SignUp').default
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: require('@/pages/TermsOfService').default
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: require('@/pages/PrivacyPolicy').default
    },
    {
      path: '*',
      name: 'errors.404',
      component: require('@/pages/PageNotFound404').default
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js